import React from 'react';
import SubjectPage from '../structure/SubjectPage';
import Accordions from '../../../components/Dropdowns';

const PSLP = ({ branch = "CSE", semester = "4th Semester" }) => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Basics: Probability and Statistical models, Sample Spaces and Events, Counting Techniques, Interpretations and Axioms of Probability, Unions of Events and Addition Rules, Conditional Probability, Intersections of Events and Multiplication and Total Probability Rules, Independence, Bayes’ Theorem, Random Variables. Discrete and Continuous Random Variables and Distributions: Probability Distributions and Probability Mass / density Functions, Cumulative Distribution Functions, Mean and Variance of a Random Variable, Discrete and continuous Uniform Distribution, Binomial Distribution, Geometric and Negative Binomial Distributions, Hypergeometric Distribution, Poisson Distribution. Normal Distribution, Normal Approximation to the Binomial, and Poisson Distributions; Exponential Distribution, Erlang and Gamma Distributions, Weibull Distribution, Lognormal Distribution, Beta Distribution.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Joint Probability Distributions for Two Random Variables, Conditional Probability Distributions and Independence, Joint Probability Distributions for Two Random Variables, Covariance and Correlation, Common Joint Distributions, Linear Functions of RandomVariables, General Functions of Random Variables, Moment-Generating Functions. Numerical Summaries of Data, Stem-and-Leaf Diagrams, Frequency Distributions and Histograms, Box Plots, Time Sequence Plots, Scatter Diagrams, Probability Plots. Point Estimation, Sampling Distributions and the Central Limit Theorem without proof, General Concepts of Point Estimation, Methods of Point Estimation, Statistical Intervals for a Single Sample.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Hypotheses Testing for a SingleSample: Tests on the Mean of a Normal Distribution with Variance Known / Unknown, Tests on the Variance and Standard Deviationof a Normal Distribution, Tests on a Population Proportion, Testing for Goodness of Fit, Nonparametric tests (Signed, Wilcoxon), Similarly Statistical Inference forTwo Samples. Regression and Correlation: Linear Regression, Least Squares Estimators, Hypotheses testing for simple linear regression, Confidence Intervals, Adequacy of model, Correlation, Transformed Variables, Logistic Regression. Similarly, for multiple linear regression including aspects of MLR. </p>
    </div>,
    <div key="4" className="p-4">
      <p>Linear Programming: Introduction, formulation of problem, Graphical method, Canonical and Standard form of LPP, Simplex method, Duality concept, Dual simplex method, Transportation and Assignment problem.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: <Accordions accordionContent={accordionContent} />,
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'important',
      label: 'Important',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'videos',
      label: 'Video Lectures',
      content: null, // Managed by SubjectPage
    }
  ];

  return (
    <SubjectPage
      subjectName="Probability Statistics and Linear Programming"
      subjectKey="pslp"
      branch={branch}
      semester={semester}
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'PSLPNotes',
        videos: 'PSLPVideos'
      }}
    />
  );
};

export default PSLP;
